(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/dialogs/payment-error.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/dialogs/payment-error.js');

'use strict';

class PaymentError extends svs.tur.payment.dialogs.DialogBase {
  constructor(_ref) {
    let {
      onConfirm = () => {},
      errorTitle,
      errorMessage
    } = _ref;
    super({
      onConfirm
    });
    this.errorMessage = errorMessage;
    this.errorTitle = errorTitle;
    this.show();
  }
  getType() {
    return svs.components.dialog.type.ERROR;
  }
  getIcon() {
    return 'exclamation-sign';
  }
  getTitle() {
    return this.errorTitle;
  }
  getMessage() {
    return [{
      type: svs.components.dialog.message.TEXT,
      text: this.errorMessage,
      align: svs.components.dialog.message.align.CENTER
    }];
  }
  getActions() {
    return [{
      type: svs.components.dialog.button.SECONDARY,
      title: 'Okej',
      callback: (e, form, dialog) => {
        dialog.close();
        this.onConfirm && this.onConfirm();
      }
    }];
  }
}
svs.tur.payment.dialogs.PaymentError = PaymentError;

 })(window);